import _typeof from '@babel/runtime/helpers/typeof';
import { defaultTheme } from './Theme.js';

function isValidThemeSection(value) {
  return value in defaultTheme;
}
var validateTheme = function validateTheme(theme) {
  if (_typeof(theme) !== 'object' || theme === null) {
    throw Error("Expected an object, instead received \"".concat(theme === null ? 'null' : _typeof(theme), "\""));
  }
  Object.keys(theme).forEach(function (key) {
    if (!isValidThemeSection(key)) {
      throw Error("Invalid property provided for Theming configuration: property with key \"".concat(key, "\" does not exist"));
    }
  });
  Object.keys(defaultTheme).forEach(function (key) {
    if (!theme[key]) {
      throw Error("Invalid theme provided for elemental-ui - key: ".concat(key, " is defined by the defaultTheme but not provided by the given theme"));
    }
  });
  return theme;
};

export { validateTheme };
